export default __webpack_public_path__ + "static/media/BOD Special Meeting 20 January 2021.4a65d8f9.pdf";